/** @jsxImportSource @emotion/react */

import { css } from "@emotion/react";
import { BottomNavigation, BottomNavigationAction } from "@mui/material";
import SearchDrarwer from "component/molecule/SearchDrawer";
import { useState } from "react";
import { FaHome, FaRegListAlt, FaRegMap, FaSearch } from "react-icons/fa";
// import { GiHamburgerMenu } from "react-icons/gi";
import { PiAirplaneTakeoffFill } from "react-icons/pi";
import { Link, useNavigate } from "react-router-dom";
import { kakaomapAddDocument } from "service/kakaomapService";
// import { searchDrawerCategoryAddDocument } from "service/searchDrawerService";
import { searchDrawerAddressAddDocument } from "service/searchDrawerService";

function MainLayout({children}: any) {
    const [openDrawer, setOpenDrawer] = useState(false)

    const [footerValue, setFooterValue] = useState("")

    const navigate = useNavigate();

    const onClickHamberger = () => {
        // kakaomapAddDocument()
        // searchDrawerCategoryAddDocument()
        searchDrawerAddressAddDocument()
    }

    return (
        <>
            <header css={HeaderStyle}>
                <h1 css={HeaderTitleStyle}>
                    <PiAirplaneTakeoffFill size={40}/>
                    <span css={css`color: var(--primary-color);`}>Enjoy</span>
                    <span css={css`color: var(--secondary-color);`}>My</span>
                    <span css={css`color: var(--secondary-color);`}>Place</span>
                </h1>
                {/* <button css={HeaderButtonStyle} onClick={onClickHamberger}><GiHamburgerMenu size={40} color="black" /></button> */}
            </header>

            <main css={MainStyle}>
                {/* Left Section */}
                <section css={LeftSectionStyle}>
                    <div css={LeftSectionButtonWrapperStyle}>
                        <Link to='/' css={LeftSectionMapButtonStyle}>
                            <FaRegMap />
                            &nbsp; 지도보기
                        </Link>
                        <div css={LeftSectionListButtonStyle}>
                            <FaRegListAlt />
                            &nbsp; 목록보기
                        </div>
                    </div>
                </section>

                {/* Right Section */}
                <section css={RightSectionStyle}>
                    <section css={MainContentsStyle}>
                        {children}
                    </section>

                    {/* <footer css={FooterStyle}>
                        <div css={FooterMenuWrapperStyle}>
                            <Link to='/' css={FooterMapButtonStyle}>
                                <FaRegMap />
                                &nbsp; 지도보기
                            </Link>
                            <Link to="/place-list" css={FooterListButtonStyle}>
                                <FaRegListAlt />
                                &nbsp; 목록보기
                            </Link>
                            <div css={FooterSearchButtonStyle} onClick={() => setOpenDrawer(true)}>
                                <FaSearch />
                                &nbsp; 지역검색
                            </div>
                        </div>
                        <div css={FooterInfoWrapperStyle}>
                            <div css={FooterInfoStyle}>PeachBloom</div>
                            <div css={FooterInfoStyle}>gongkni159@gmail.com</div>
                        </div>
                    </footer> */}

                    <BottomNavigation
                        showLabels
                        value={footerValue}
                        onChange={(event, newValue) => {
                            // setFooterValue(newValue);

                            if(newValue === "home") {
                                navigate("/")
                            }
                            if(newValue === "map") {
                                navigate("/place-map")
                            }
                            if(newValue === "list") {
                                navigate("/place-list")
                            }
                            if(newValue === "search") {
                                setOpenDrawer(true)
                            }
                        }}
                        css={FooterStyle}
                    >
                        <BottomNavigationAction 
                            label="home" 
                            value="home"
                            icon={<FaHome />} 
                            css={FooterButtonStyle}
                        />
                        <BottomNavigationAction 
                            label="지도보기" 
                            value="map"
                            icon={<FaRegMap />} 
                            css={FooterButtonStyle}
                        />
                        <BottomNavigationAction 
                            label="목록보기" 
                            value="list"
                            icon={<FaRegListAlt />} 
                            css={FooterButtonStyle}
                        />
                        <BottomNavigationAction 
                            label="검색" 
                            value="search"
                            icon={<FaSearch />} 
                            css={FooterButtonStyle}
                        />
                    </BottomNavigation>
                </section>
            </main>

            <SearchDrarwer openDrawer={openDrawer} setOpenDrawer={setOpenDrawer} />
        </>
    )
}

const HeaderStyle = css`
    /* padding: 20px; */
    padding-left: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 60px;
`

const HeaderTitleStyle = css`
    display: flex;
    justify-content: start;
    align-items: center;
`

const HeaderButtonStyle = css`
    background-color: white;
    border: 0;
    cursor: pointer;
`

const MainStyle = css`
    display: flex;
    width: 100%;
    height: 100%;
`

const LeftSectionStyle = css`
    display: none;
    /* @media screen and (min-width: 1024px) {
        display: block;
        width: 350px;
    } */
`

const LeftSectionButtonWrapperStyle = css`
    display: flex;
    justify-content: center;
    background-color: var(--secondary-color);
    padding: 30px 0;
`

const LeftSectionMapButtonStyle = css`
    text-align: center;
    font-size: 14px;
    font-weight: 700;
    margin: 0 10px;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    text-decoration: none;
    color: var(--primary-color);
`

const LeftSectionListButtonStyle = css`
    text-align: center;
    font-size: 14px;
    font-weight: 700;
    margin: 0 10px;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    text-decoration: none;
    color: var(--quarternary-color);
`

const RightSectionStyle = css`
    display: flex;
    flex-direction: column;
    width: 100%;
    /* @media screen and (min-width: 1024px) {
        width: calc(100% - 350px);
    } */
`

const MainContentsStyle = css`
    display: flex;
    width: 100%;
    height: 100%;
`

const FooterStyle = css`
    /* height: 10vh; */
    /* margin-top: 10px; */
    width: 100%;
    /* height: 90px; */

    position: fixed;
    bottom: 0;
`

const FooterButtonStyle = css`
    text-align: center;
    font-size: 20px;
    font-weight: 700;
`

const FooterMenuWrapperStyle = css`
    display: flex;
    align-items: center;
    width: 100%;
    height: 50px;
    /* @media screen and (min-width: 1024px) {
        display: none
    } */
`

const FooterMapButtonStyle = css`
    width: calc(100% / 3);
    height: 100%;
    text-align: center;
    padding: 10px;
    font-size: 14px;
    font-weight: 700;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    text-decoration: none;
    background-color: var(--secondary-color);
    color: var(--primary-color);
`

const FooterListButtonStyle = css`
    width: calc(100% / 3);
    height: 100%;
    text-align: center;
    padding: 10px;
    font-size: 14px;
    font-weight: 700;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    text-decoration: none;
    background-color: var(--tertiay-color);
    color: var(--quarternary-color);
`

const FooterSearchButtonStyle = css`
    width: calc(100% / 3);
    height: 100%;
    text-align: center;
    padding: 10px;
    font-size: 14px;
    font-weight: 700;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    text-decoration: none;
    background-color: var(--primary-color);
    color: var(--secondary-color);
`

const FooterInfoWrapperStyle = css`
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 10px;
`

const FooterInfoStyle = css`
    margin: 3px;
    padding: 0 10px;
    color: #666;
    font-size: 14px;
    font-weight: 300;

    :not(:last-child) {
        border-right: 2px solid #666; 
    }
`

export default MainLayout;